import React from 'react';

import {
  PartnerBindingFormValues,
  PartnerBindingFormViolation,
} from 'types/partnerBindingFormTypes';
import { createPartnerBindingFormViolationLense } from 'utils/partnerBindingFormUtils';

const initialValues: PartnerBindingFormValues = {
  partnerCode: '',
};

export const usePartnerBindingForm = () => {
  const [values, setValues] = React.useState<PartnerBindingFormValues>(
    initialValues
  );

  const [violations, setViolations] = React.useState<
    PartnerBindingFormViolation[]
  >([]);

  const setPartnerCode = React.useCallback((nextValue: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      partnerCode: nextValue,
    }));

    setViolations((prev) =>
      prev.filter(
        (violation) =>
          !createPartnerBindingFormViolationLense(
            violation
          ).isPartnerCodeViolation()
      )
    );
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setPartnerCode,
  };
};
